export { SoldToAddressDetailsWrapper } from './src/sold-to-address-details-wrapper';
